/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Acquisitionhandoveremail3Inputs */

const de__field_acquisitionhandoveremail3 = /** @type {(inputs: _Field_Acquisitionhandoveremail3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übergabe-E-Mail-Datum`)
};

/**

* @param {_Field_Acquisitionhandoveremail3Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_acquisitionhandoveremail3 = /** @type {((inputs?: _Field_Acquisitionhandoveremail3Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Acquisitionhandoveremail3Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_acquisitionhandoveremail3(inputs)
});
export { _field_acquisitionhandoveremail3 as "_field_acquisitionHandOverEmail" }